import { render } from "./ResourceListRow.vue?vue&type=template&id=5a59545e&ts=true"
import script from "./ResourceListRow.vue?vue&type=script&lang=ts"
export * from "./ResourceListRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__